module.exports = __webpack_public_path__ + "static/media/it.96e35a6b.svg";